import React from 'react';
import { Switch, Route } from 'react-router-dom';
import HomePage from './HomePage';
import Quotation from '../components/Quotation/Quotation';
import { QUOTATION_PATH } from '../constants/quotation';

const AppRouter = () => {
    return (
        <Switch>
            <Route path={QUOTATION_PATH}>
                <Quotation />
            </Route>
            <Route path="/">
                <HomePage />
            </Route>
        </Switch>
    );
};

export default AppRouter;
